import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import useFetch from "../../../hooks/useFetch";

const HAFHDosDont = ({ t, role, hostelCode }) => {
  const authState = useSelector((state) => state.authReducer);
  const [fetchData] = useFetch();
  const [content, setContent] = useState("");

  const fetchDosDont = async () => {
    try {
      const res = await fetchData({
        url: "/hafh/core/dosdont/get",
        method: "post",
        data: { hostelCode },
        headers: {
          Authorization: authState.token,
        },
      });

      if (res?.status) {
        setContent(res?.record?.dosdont || "");
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (hostelCode) fetchDosDont();
  }, [hostelCode]);

  return (
    <div className="bg-gray-800 p-5 rounded-xl text-white space-y-4">

      <h2 className="text-yellow-300 text-lg font-semibold">
        Hostel Do’s & Don’ts
      </h2>

      <div
        className="text-gray-200 text-sm leading-relaxed"
        dangerouslySetInnerHTML={{ __html: content }}
      />

    </div>
  );
};

export default HAFHDosDont;